import { render, staticRenderFns } from "./DetailApple.vue?vue&type=template&id=3405bf8e&scoped=true&"
import script from "./DetailApple.vue?vue&type=script&lang=ts&"
export * from "./DetailApple.vue?vue&type=script&lang=ts&"
import style0 from "./DetailApple.vue?vue&type=style&index=0&id=3405bf8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405bf8e",
  null
  
)

export default component.exports